import * as yup from 'yup';

export const schema = yup.object().shape({
  stoolType: yup.string().nullable(),
});
